// extracted by mini-css-extract-plugin
module.exports = {"flex_cc":"patientDetailCard_flex_cc__38luw"};